import { SyntheticEvent } from 'react';

import { Tag, Tags } from '../../interfaces';
import { deepCopy } from '../../utils';
import { handleValueBool, handleValueEnum, handleValueInt } from '../event_details/EventTags/handleClickLogic';

export const getTargetWidth = (cols: number): number => {
  if (cols === 4) {
    return 120;
  }
  if (cols === 3) {
    return 160;
  }
  return 200;
};

export const handleButtonClick =
  (tag: Tag, idOfValue: string, tags: Tags, setTags: (tags: Tags) => void, onUserTagChange: (tags: Tags) => void) =>
  async (evt?: SyntheticEvent | any) => {
    const { value_type } = tag;
    const path = `td:${tag.id.toString()}`;
    const newValue = deepCopy(tags);

    if (value_type === 'bool') {
      await handleValueBool(newValue, path);
    } else if (value_type === 'int') {
      await handleValueInt(newValue, path, tag, idOfValue, evt);
    } else if (value_type === 'enum') {
      // FIXMXE support for multiple values, if ever needed
      await handleValueEnum(newValue, path, idOfValue);
    }

    setTags(newValue);

    onUserTagChange?.(newValue);
  };

export const handleDropdownClick =
  (
    tag: Tag,
    path: string,
    value: string,
    tags: Tags,
    setTags: (tags: Tags) => void,
    onUserTagChange: (tags: Tags) => void,
  ) =>
  (evt?: SyntheticEvent | any) => {
    if (tag.value_type === 'bool') {
      const newValue = deepCopy(tags);
      newValue[path] = value;
      setTags(newValue);
      onUserTagChange?.(newValue);
    } else {
      handleButtonClick(tag, value, tags, setTags, onUserTagChange)(evt);
    }
  };

export const handleTagClick =
  (path: string, tags: Tags, setTags: (tags: Tags) => void, onUserTagChange: (tags: Tags) => void) =>
  (evt?: SyntheticEvent | any) => {
    const newTags = deepCopy(tags);
    delete newTags[path];
    setTags(newTags);
    onUserTagChange?.(newTags);
  };
